<template>
  <a-pagination
    v-if="isUsePag"
    show-size-changer
    show-quick-jumper
    :total="pagination.total"
    :current="pagination.current"
    :page-size="pagination.pageSize"
    :page-size-options="pagination.pageSizeOptions"
    :show-total="pagination.showTotal"
    @showSizeChange="onShowSizeChange"
    @change="onChange"
  />
</template>
<script>
export default {
  name: "UsePagination",
  props: {
    totals: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 1
    },
    isUsePag: {
      type: Boolean,
      default: true
    },
    pageSizeNum:{
      type: [String,Number],
      default: 10
    },
    pageSizeOptions:{
      type: Array,
      default:()=> ["10", "30", "50", "100", "200"]
    },
  },
  data() {
    return {
      pagination: {
        current: 1,
        total: this.totals,
        pageSize: this.pageSizeNum,
        pageSizeOptions:this.pageSizeOptions,
        // pageSizeOptions: ["10", "30", "50", "100", "200"],
        showTotal: this.showTotal
      }
    };
  },
  watch: {
    totals(n, o) {
      this.pagination.total = n;
    },
    current(n, o) {
      this.pagination.current = n;
    }
  },
  methods: {
    showTotal(total, range) {
      return `共 ${total} 条记录`;
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.paginationEvent({ page: current, pageSize: pageSize });
    },

    onChange(page, pageSize) {
      this.pagination.current = page;
      this.paginationEvent({ page: page, pageSize: pageSize });
    },
    paginationEvent(arr) {
      this.$emit("pagination-event", arr);
    }
  },
  mounted() {
    console.log(this.pageSizeOptions);
  }
};
</script>

<style scoped>
.use-table .ant-table .ant-table-footer {
  text-align: right !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UsePagination.vue